import React from "react";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomChip from "../CustomComponents/CustomChip/CustomChip";
import { preDefinedThemeColor } from "../../assets/jss/preDefinedColor";
import { useStyles } from "../../assets/jss/WallofLegendsScoreCard";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import clsx from "clsx";
import trackEvents from "../../assets/appInsightsEvents";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import { useParams } from "react-router-dom";

export default function ScoreCard(props) {
  const params = useParams();
  const classes = useStyles();
  const { label, score, color, dataLoaded, isApiFailed, statId } = props.scoreInfo;
  const preDefinedColor = preDefinedThemeColor;
  const [isGroupScoped, setIsGroupScoped] = React.useState(props.isGroupScoped)

  React.useEffect(() => {
    setIsGroupScoped(props.isGroupScoped);
  }, [props.isGroupScoped])

  const handleTileClick = () => {
    trackEvents("Score card", {
      page: props.typeOfScore.toUpperCase(),
      value: label,
      selectedStatId: statId,
    }, params);
    props.handleTileClick({
      color: color,
      typeOfScore: props.typeOfScore,
      selectedStatId: statId,
      label,
    });
  };

  return (
    <>
      {dataLoaded && (
        <CustomPaper
          elevation={0}
          className={clsx(
            classes.paper,
            statId === props.selectedStatId && (isGroupScoped === true || (isGroupScoped === false && props.showLimitedDriver === 0)) ? classes.highlight : null
          )}
          onClick={handleTileClick}
        >
          <CustomChip
            label={score}
            style={{
              backgroundColor: preDefinedColor[color],
              color: color === "grey" ? "" : "#FFFFFF",
            }}
            className={classes.chip}
          />
          <CustomTypography
            component="h1"
            variant="h5"
            className={classes.title}
          >
            {label}{" "}
          </CustomTypography>
        </CustomPaper>
      )}
      {!dataLoaded && !isApiFailed && (
        <CustomPaper className={classes.loadingContainer} elevation={0}>
          <CustomCircularProgress />
        </CustomPaper>
      )}
      {isApiFailed && (
        <CustomPaper
          elevation={0}
          className={clsx(
            classes.paper,
            classes.paperDisabled
          )}
        >
          <CustomSkeleton
            className={classes.chipSkeleton}
            animation="wave"
            width={120}
            height={60}
          />
          <CustomTypography
            component="h1"
            variant="h5"
            className={clsx(classes.title, classes.titleDisabled)}
          >
            {label}{" "}
          </CustomTypography>
        </CustomPaper>
      )}
    </>
  );
}
